if (!customElements.get('collection-video')) {
  class CollectionVideo extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.control = this.querySelector('[data-collection-video-toggle]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.breakpoint = window.matchMedia('(min-width: 768px)');

      if (!this.videos.length || !this.control) return;

      this.videos.forEach((video) => {
        video.muted = true;
        video.removeAttribute('controls');
      });

      this.control.addEventListener('click', this.toggle.bind(this));
      this.videos.forEach((video) => {
        video.addEventListener('play', () => this.syncControl());
        video.addEventListener('pause', () => this.syncControl());
      });
      this.breakpoint.addEventListener('change', () => this.handleBreakpointChange());

      this.observe();
      this.syncControl();
    }

    get activeVideo() {
      return this.videos.find((video) => video.offsetParent !== null) || this.videos[0];
    }

    playActive() {
      const active = this.activeVideo;
      if (!active) return;

      this.videos.forEach((video) => {
        if (video !== active && !video.paused) video.pause();
      });

      const playback = active.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch(() => this.syncControl());
      }
    }

    toggle() {
      const active = this.activeVideo;
      if (!active) return;

      if (active.paused) {
        this.pausedByUser = false;
        this.playActive();
      } else {
        this.pausedByUser = true;
        active.pause();
      }
    }

    syncControl() {
      const active = this.activeVideo;
      if (!active || !this.control) return;

      const playing = !active.paused && !active.ended;
      const label = playing ? 'Pause video' : 'Play video';

      this.control.setAttribute('aria-pressed', playing ? 'true' : 'false');
      this.control.setAttribute('aria-label', label);
      this.control.textContent = label;
    }

    handleBreakpointChange() {
      const wasPlaying = this.videos.some((video) => !video.paused);
      this.videos.forEach((video) => {
        if (!video.paused) video.pause();
      });
      if (wasPlaying && !this.pausedByUser && this.inViewport) this.playActive();
    }

    observe() {
      if ('IntersectionObserver' in window === false) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inViewport = entry.isIntersecting;
          if (entry.isIntersecting) {
            if (!this.reducedMotion.matches && !this.pausedByUser) this.playActive();
          } else {
            this.videos.forEach((video) => {
              if (!video.paused) video.pause();
            });
          }
        });
      }, { rootMargin: '0px 0px 200px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('collection-video', CollectionVideo);
}
